import React from "react";
import style from "./index.module.scss";

interface SubModalTitleProps {
    onClose?: () => void;
    title: string;
    parentTitle: string;
}

export default function SubModalTitle({
    onClose,
    title,
    parentTitle
}: SubModalTitleProps) {
    return (
        <div className={style.root}>
            <span className={style.link} onClick={onClose}>
                {parentTitle}
            </span>{" "}
            &gt; {title}
        </div>
    );
}
